export default __webpack_public_path__ + "static/survey-insights-dark-mode-8af92c69ee177f23342828ff55af8644.mp4";